module.exports = `
.react-jinke-music-player-main.light-theme .loading svg {
    color: #5f5fc4;
    font-size: 24px
}

.react-jinke-music-player-mobile-play-model-tip {
    background-color: #5f5fc4;
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle, .react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-track {
    background-color: #5f5fc4
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle:active {
    box-shadow: 0 0 2px #5f5fc4
}

.react-jinke-music-player-main.light-theme .audio-item.playing svg {
    color: #5f5fc4
}

.react-jinke-music-player-main.light-theme .audio-item.playing .player-singer {
    color: #5f5fc4 !important
}

.audio-lists-panel-content .audio-item.playing, .audio-lists-panel-content .audio-item.playing svg {
    color: #5f5fc4
}
.audio-lists-panel-content .audio-item:active .group:not([class=".player-delete"]) svg, .audio-lists-panel-content .audio-item:hover .group:not([class=".player-delete"]) svg {
    color: #5f5fc4
}

.react-jinke-music-player-main.light-theme ::-webkit-scrollbar-thumb {
    background-color: #5f5fc4;
}

.react-jinke-music-player-main.light-theme svg {
    color: #5f5fc4
}

.react-jinke-music-player-main.light-theme svg:active, .react-jinke-music-player-main.light-theme svg:hover {
    color: #7171d5
}

.react-jinke-music-player-main.light-theme .rc-slider-rail {
    background-color: rgba(0, 0, 0, .09) !important
}

.react-jinke-music-player-main.light-theme .music-player-controller {
    background-color: #fff;
    border-color: #fff
}

.react-jinke-music-player-main.light-theme .music-player-panel {
    background-color: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 34, 77, .05);
    color: #5f5fc4
}

.react-jinke-music-player-main.light-theme .music-player-panel .img-content {
    box-shadow: 0 0 10px #dcdcdc
}

.react-jinke-music-player-main.light-theme .music-player-panel .progress-load-bar {
    background-color: rgba(0, 0, 0, .06) !important
}

.react-jinke-music-player-main.light-theme .rc-switch {
    color: #fff
}

.react-jinke-music-player-main.light-theme .rc-switch:after {
    background-color: #fff
}

.react-jinke-music-player-main.light-theme .rc-switch-checked {
    background-color: #5f5fc4 !important;
    border: 1px solid #5f5fc4
}

.react-jinke-music-player-main.light-theme .rc-switch-inner {
    color: #fff
}

.react-jinke-music-player-main.light-theme .audio-lists-btn {
    background-color: #f7f8fa !important
}

.react-jinke-music-player-main.light-theme .audio-lists-btn:active, .react-jinke-music-player-main.light-theme .audio-lists-btn:hover {
    background-color: #fdfdfe;
    color: #444
}

.react-jinke-music-player-main.light-theme .audio-lists-btn > .group:hover, .react-jinke-music-player-main.light-theme .audio-lists-btn > .group:hover > svg {
    color: #444
}

.react-jinke-music-player-main.light-theme .audio-lists-panel {
    background-color: #fff;
    box-shadow: 0 0 2px #dcdcdc;
    color: #444
}

.react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item {
    background-color: #fff
}

.react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item:nth-child(odd) {
    background-color: #fafafa !important
}

.react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item.playing {
    background-color: #f2f2f2 !important
}

.react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item.playing, .react-jinke-music-player-main.light-theme .audio-lists-panel .audio-item.playing svg {
    color: #5f5fc4 !important
}
`
